<template>
  <div class="skills_wrap">
    <!-- 顶部区：查询条件 + 操作按钮，与数字员工页顶部同一行 -->
    <div class="staff_head">
      <el-form :inline="true" :model="queryForm" class="query_form" size="small">
        <el-form-item label="名称">
          <el-input v-model="queryForm.name" placeholder="名称模糊搜索" clearable
                    style="width: 140px" @keyup.enter.native="onSearch" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="queryForm.status" placeholder="全部" clearable style="width: 100px">
            <el-option label="草稿" value="draft" />
            <el-option label="已发布" value="published" />
            <el-option label="已归档" value="archived" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="onSearch">查询</el-button>
          <el-button size="small" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
      <div class="head_actions">
        <el-button type="primary" icon="el-icon-magic-stick" size="small" @click="openDistill">从文档蒸馏</el-button>
        <el-button type="primary" icon="el-icon-plus" size="small" @click="openAdd">新建技能</el-button>
      </div>
    </div>

    <!-- 卡片列表：与规则列表页一致，默认以卡片展示，编辑从右侧抽屉拉出 -->
    <div class="skill_cards" v-loading="loading">
      <div v-for="row in tableData" :key="row.skill_id" class="skill_card">
        <div class="card_head">
          <i class="el-icon-magic-stick card_icon"></i>
          <span class="card_name" :title="row.name">{{ row.name }}</span>
          <el-tag :type="STATUS_TAG[row.status] || 'info'" size="mini">
            {{ STATUS_TEXT[row.status] || row.status }}
          </el-tag>
          <i class="el-icon-delete card_del" title="删除" @click.stop="handleDel(row)"></i>
        </div>
        <div class="card_summary">{{ row.summary || '（暂无说明）' }}</div>
        <div class="card_meta">
          <div class="meta_row"><span class="meta_k">最新版本</span><span>{{ row.latest_ver ? 'v' + row.latest_ver : '-' }}</span></div>
          <div class="meta_row"><span class="meta_k">已发布</span><span>{{ row.published_ver ? 'v' + row.published_ver : '-' }}</span></div>
          <div class="meta_row"><span class="meta_k">更新时间</span><span>{{ fmtTime(row.utime) }}</span></div>
        </div>
        <div class="card_tags">
          <el-tag v-for="t in row.tags || []" :key="t" size="mini" type="info">{{ t }}</el-tag>
          <span v-if="!(row.tags && row.tags.length)" class="tag_empty">无标签</span>
        </div>
        <div class="card_actions">
          <el-button type="text" size="small" @click="openDetail(row)">详情</el-button>
          <el-button type="text" size="small" @click="openEditFromCard(row)">编辑</el-button>
          <el-button v-if="row.status === 'draft'" type="text" size="small"
                     :loading="pubListId === row.skill_id" @click="pubFromList(row)">发布</el-button>
        </div>
      </div>
      <el-empty v-if="!loading && !tableData.length" description="暂无技能数据" class="cards_empty" />
    </div>


    <!-- 底部分页：固定在卡片区下方，与数字员工页一致 -->
    <div class="pager_bar">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagesize"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </div>

    <!-- 手动新建 -->
    <el-dialog title="新建技能" :visible.sync="addVisible" width="520px" v-dialogDrag
               :modal-append-to-body="false" v-if="addVisible">
      <el-form ref="addForm" :model="addForm" :rules="addRules" label-width="80px">
        <el-form-item label="技能名" prop="name">
          <el-input v-model="addForm.name" maxlength="64" placeholder="同账号下唯一，将创建 v1 草稿" />
        </el-form-item>
        <el-form-item label="说明">
          <el-input v-model="addForm.summary" type="textarea" :rows="3" maxlength="500" />
        </el-form-item>
        <el-form-item label="标签">
          <el-input v-model="addForm.tags" placeholder="多个标签用英文逗号分隔" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="addVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submiting" @click="submitAdd">创 建</el-button>
      </div>
    </el-dialog>

    <!-- 蒸馏向导 -->
    <el-dialog title="从文档蒸馏技能" :visible.sync="distillVisible" width="720px" v-dialogDrag
               :modal-append-to-body="false" v-if="distillVisible" :close-on-click-modal="false"
               :before-close="onDistillBeforeClose">
      <el-steps :active="dStep" simple>
        <el-step title="选择知识库" />
        <el-step title="选择文档" />
        <el-step title="蒸馏进度" />
      </el-steps>

      <div v-if="dStep === 0" class="d_step">
        <el-select v-model="dForm.kb_id" placeholder="选择知识库" style="width: 100%"
                   :loading="kbsLoading" @change="onPickKb">
          <el-option v-for="kb in kbs" :key="kb.kb_id" :label="kb.name" :value="kb.kb_id" />
        </el-select>
      </div>

      <div v-else-if="dStep === 1" class="d_step">
        <el-table :data="docs" v-loading="docsLoading" border size="small" height="280"
                  highlight-current-row @current-change="onPickDoc">
          <el-table-column label="" width="50" align="center">
            <template slot-scope="scope">{{ dForm.doc_id === scope.row.doc_id ? '●' : '' }}</template>
          </el-table-column>
          <el-table-column prop="title" label="文档标题" min-width="200" show-overflow-tooltip />
          <el-table-column prop="filename" label="文件名" min-width="160" show-overflow-tooltip />
          <el-table-column label="大小" width="90" align="right">
            <template slot-scope="scope">{{ fmtSize(scope.row.size) }}</template>
          </el-table-column>
        </el-table>
        <el-input v-model="dForm.name" maxlength="64" style="margin-top: 10px"
                  placeholder="技能名（留空使用文档标题）" />
      </div>

      <div v-else class="d_step">
        <div v-if="dProg.stages.length" class="stage_list">
          <div v-for="(s, i) in dProg.stages" :key="i" class="stage_item">
            <i :class="i < dProg.stages.length - 1 || dProg.result ? 'el-icon-success stage_ok' : 'el-icon-loading stage_run'" />
            <span>{{ s.text }}</span>
          </div>
        </div>
        <div v-else-if="!dProg.result" class="stage_empty">正在连接…</div>

        <el-collapse>
          <el-collapse-item :title="'思考过程' + (dProg.thinks ? '（' + dProg.thinks.length + ' 字）' : '')">
            <pre class="stream_pre">{{ dProg.thinks || '（暂无）' }}</pre>
          </el-collapse-item>
          <el-collapse-item title="生成内容（技能卡 JSON 片段，非自然语言）">
            <pre class="stream_pre code_view"><code>{{ dProg.reply || '（暂无）' }}</code></pre>
          </el-collapse-item>
        </el-collapse>

        <div v-if="dProg.result" class="result_card">
          <el-alert v-if="dProg.result.degraded" type="warning" :closable="false" show-icon
                    title="蒸馏降级为骨架版（distill_degraded），需编辑补全流程后才能发布" />
          <div class="kv"><span class="k">技能</span><span>{{ dProg.result.name }}</span></div>
          <div class="kv"><span class="k">版本</span><span>v{{ dProg.result.version }}（草稿）</span></div>
          <div class="kv"><span class="k">生成方式</span><span>{{ GEN_TEXT[dProg.result.gen_by] || dProg.result.gen_by }}</span></div>
          <div class="kv"><span class="k">反思轮次</span><span>{{ dProg.result.reflect_rounds }}</span></div>
        </div>
      </div>

      <div slot="footer">
        <el-button v-if="dStep === 1" @click="dStep = 0">上一步</el-button>
        <el-button v-if="dStep === 0" :disabled="!dForm.kb_id" type="primary" @click="toStepDocs">下一步</el-button>
        <el-button v-else-if="dStep === 1" :disabled="!dForm.doc_id" type="primary" :loading="distilling"
                   @click="runDistill">开始蒸馏</el-button>
        <el-button v-if="distilling" @click="cancelDistill">取消展示</el-button>
        <el-button v-if="dProg.result" type="primary" @click="viewDistilled">查看技能</el-button>
        <el-button v-if="!distilling" @click="distillVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 详情 -->
    <el-dialog :title="'技能详情：' + (skill.name || '')" :visible.sync="detailVisible" width="960px" v-dialogDrag
               :modal-append-to-body="false" v-if="detailVisible" top="5vh">
      <div class="detail_body">
        <div class="skill_info">
          <div class="kv"><span class="k">状态</span>
            <el-tag :type="STATUS_TAG[skill.status] || 'info'" size="small">{{ STATUS_TEXT[skill.status] || skill.status }}</el-tag>
          </div>
          <div class="kv"><span class="k">生成方式</span><span>{{ GEN_TEXT[latestGenBy] || latestGenBy || '-' }}</span></div>
          <div class="kv"><span class="k">最新版本</span><span>{{ skill.latest_ver ? 'v' + skill.latest_ver : '-' }}</span></div>
          <div class="kv"><span class="k">已发布</span><span>{{ skill.published_ver ? 'v' + skill.published_ver : '-' }}</span></div>
          <div class="kv"><span class="k">说明</span><span>{{ skill.summary || '-' }}</span></div>
          <div class="kv"><span class="k">标签</span><span>{{ (skill.tags || []).join('、') || '-' }}</span></div>
        </div>

        <el-tabs v-model="detailTab">
          <el-tab-pane label="版本管理" name="versions">
            <el-table :data="versions" v-loading="verLoading" border size="small">
              <el-table-column label="版本" width="70" align="center">
                <template slot-scope="scope">v{{ scope.row.version }}</template>
              </el-table-column>
              <el-table-column label="状态" width="90">
                <template slot-scope="scope">
                  <el-tag :type="STATUS_TAG[scope.row.status] || 'info'" size="small">
                    {{ STATUS_TEXT[scope.row.status] || scope.row.status }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="生成方式" width="90">
                <template slot-scope="scope">{{ GEN_TEXT[scope.row.gen_by] || scope.row.gen_by }}</template>
              </el-table-column>
              <el-table-column prop="revision" label="修订号" width="70" align="center" />
              <el-table-column prop="change_log" label="变更说明" min-width="140" show-overflow-tooltip />
              <el-table-column label="更新时间" width="150">
                <template slot-scope="scope">{{ fmtTime(scope.row.utime) }}</template>
              </el-table-column>
              <el-table-column label="操作" width="260" fixed="right">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="viewVersion(scope.row)">查看</el-button>
                  <el-button v-if="scope.row.status === 'draft'" type="text" size="small"
                             @click="startEdit(scope.row, skill.skill_id)">编辑</el-button>
                  <el-button v-if="scope.row.status === 'draft'" type="text" size="small"
                             :loading="reflectVer === scope.row.version" @click="doReflect(scope.row)">反思</el-button>
                  <el-tooltip v-if="scope.row.status === 'draft' && scope.row.gen_by === 'distill_degraded'"
                              content="降级骨架版本禁止直接发布，请先编辑补全流程" placement="top">
                    <span><el-button type="text" size="small" disabled>发布</el-button></span>
                  </el-tooltip>
                  <el-button v-else-if="scope.row.status === 'draft'" type="text" size="small"
                             :loading="pubVerNo === scope.row.version" @click="pubVersion(scope.row)">发布</el-button>
                  <el-button type="text" size="small" @click="newVersion(scope.row)">复制新版本</el-button>
                </template>
              </el-table-column>
            </el-table>

            <!-- 版本详情（只读） -->
            <div v-if="curVer" class="ver_detail">
              <h4>版本详情：v{{ curVer.version }}
                <el-tag :type="STATUS_TAG[curVer.status] || 'info'" size="mini">{{ STATUS_TEXT[curVer.status] || curVer.status }}</el-tag>
                <span class="ver_meta">修订号 {{ curVer.revision }} · 反思 {{ curVer.reflect_rounds || 0 }} 轮 · {{ GEN_TEXT[curVer.gen_by] || curVer.gen_by }}</span>
              </h4>
              <div class="kv"><span class="k">卡名</span><span>{{ card.name || '-' }}</span></div>
              <div class="kv"><span class="k">卡说明</span><span>{{ card.summary || '-' }}</span></div>
              <div class="kv"><span class="k">输出格式</span><span>{{ card.output_format || '-' }}</span></div>

              <h5>输入参数（{{ (card.inputs || []).length }}）</h5>
              <el-table :data="card.inputs || []" border size="mini" empty-text="无输入参数">
                <el-table-column prop="name" label="参数名" min-width="120" />
                <el-table-column label="说明" min-width="180" show-overflow-tooltip>
                  <template slot-scope="scope">{{ scope.row.desc || '-' }}</template>
                </el-table-column>
                <el-table-column label="必填" width="60" align="center">
                  <template slot-scope="scope">{{ scope.row.required ? '是' : '否' }}</template>
                </el-table-column>
              </el-table>

              <h5>流程节点（{{ (card.nodes || []).length }}）</h5>
              <div v-for="n in card.nodes || []" :key="n.id" class="node_card">
                <div class="node_head">
                  <el-tag size="mini" :type="NODE_TAG[n.type] || 'info'">{{ NODE_TEXT[n.type] || n.type }}</el-tag>
                  <b>{{ n.id }}</b><span class="node_title">{{ n.title }}</span>
                </div>
                <div v-if="n.detail" class="node_detail">{{ n.detail }}</div>
                <div class="node_meta">
                  <span v-if="n.inputs && n.inputs.length">入参槽位：{{ n.inputs.join('、') }}</span>
                  <span v-if="n.on_error">异常转 {{ n.on_error }}</span>
                </div>
              </div>

              <h5>转移边（{{ (card.edges || []).length }}）</h5>
              <el-table :data="card.edges || []" border size="mini" empty-text="无转移边">
                <el-table-column prop="from" label="从" width="80" />
                <el-table-column prop="to" label="到" width="80" />
                <el-table-column label="条件" min-width="220" show-overflow-tooltip>
                  <template slot-scope="scope">{{ scope.row.cond || '（无条件）' }}</template>
                </el-table-column>
              </el-table>
            </div>

            <!-- 反思结果 -->
            <div v-if="reflectResult" class="reflect_box">
              <h4>反思结果：应用 {{ reflectResult.applied || 0 }} 个补丁</h4>
              <div v-if="(reflectResult.issues || []).length">
                <div v-for="(it, i) in reflectResult.issues" :key="i" class="issue_item">
                  <el-tag size="mini">{{ it.dimension }}</el-tag>{{ it.desc }}
                </div>
              </div>
              <div v-else class="stage_empty">未发现需修订的问题</div>
            </div>
          </el-tab-pane>

          <el-tab-pane label="绑定管理" name="bindings">
            <div class="bind_bar">
              <el-select v-model="bindForm.agent_id" placeholder="选择数字员工" size="small" style="width: 220px">
                <el-option v-for="a in agentOpts" :key="a.agent_id" :label="a.display_name || a.name" :value="a.agent_id" />
              </el-select>
              <el-select v-model="bindForm.version" size="small" style="width: 200px">
                <el-option label="跟随最新已发布版（0）" :value="0" />
                <el-option v-for="v in publishedVers" :key="v.version" :label="'固定 v' + v.version" :value="v.version" />
              </el-select>
              <el-switch v-model="bindForm.enabled" active-text="启用" />
              <el-button type="primary" size="small" :loading="bindSaving" @click="saveBind">保存绑定</el-button>
            </div>
            <el-table :data="bindings" v-loading="bindLoading" border size="small">
              <el-table-column label="数字员工" min-width="140" show-overflow-tooltip>
                <template slot-scope="scope">{{ agentName(scope.row.agent_id) }}</template>
              </el-table-column>
              <el-table-column label="版本" width="140">
                <template slot-scope="scope">{{ scope.row.version === 0 ? '跟随最新已发布版' : '固定 v' + scope.row.version }}</template>
              </el-table-column>
              <el-table-column label="启用" width="80" align="center">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.enabled ? 'success' : 'info'" size="small">{{ scope.row.enabled ? '是' : '否' }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="绑定时间" width="160">
                <template slot-scope="scope">{{ fmtTime(scope.row.ctime) }}</template>
              </el-table-column>
              <el-table-column label="操作" width="80" fixed="right">
                <template slot-scope="scope">
                  <el-button type="text" size="small" class="danger_text" @click="delBind(scope.row)">解绑</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>

    <!-- 编辑草稿：从右侧抽屉拉出（仅提交改动字段，未改字段不会下发） -->
    <el-drawer :visible.sync="editVisible" direction="rtl" size="520px" :with-header="false"
               :modal="true" append-to-body :modal-append-to-body="true"
               class="skill_drawer" :before-close="closeEdit" @open="raiseDrawer">
      <div class="drawer_head">
        <span>{{ editTitle }}</span>
        <i class="el-icon-close drawer_close" @click="closeEdit"></i>
      </div>
      <div class="drawer_body">
        <el-form label-width="90px" size="small">
          <el-form-item label="卡名">
            <el-input v-model="editForm.name" maxlength="64" />
          </el-form-item>
          <el-form-item label="卡说明">
            <el-input v-model="editForm.summary" type="textarea" :rows="2" maxlength="500" />
          </el-form-item>
          <el-form-item label="输出格式">
            <el-input v-model="editForm.output_format" type="textarea" :rows="2" maxlength="500" />
          </el-form-item>
          <el-form-item label="输入参数">
            <el-table :data="editForm.inputs" border size="mini">
              <el-table-column label="参数名" min-width="100">
                <template slot-scope="scope"><el-input v-model="scope.row.name" size="mini" placeholder="槽位名" /></template>
              </el-table-column>
              <el-table-column label="说明" min-width="120">
                <template slot-scope="scope"><el-input v-model="scope.row.desc" size="mini" /></template>
              </el-table-column>
              <el-table-column label="必填" width="58" align="center">
                <template slot-scope="scope"><el-switch v-model="scope.row.required" /></template>
              </el-table-column>
              <el-table-column label="操作" width="50" align="center">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" class="danger_text" @click="removeInput(scope.$index)">删</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-button size="mini" icon="el-icon-plus" class="add_input_btn"
                       @click="editForm.inputs.push({ name: '', desc: '', required: false })">添加参数</el-button>
          </el-form-item>
          <el-form-item label="节点 nodes">
            <el-input v-model="editForm.nodesText" type="textarea" :rows="10" class="mono" />
            <div v-if="editErr.nodes" class="err_text">{{ editErr.nodes }}</div>
          </el-form-item>
          <el-form-item label="边 edges">
            <el-input v-model="editForm.edgesText" type="textarea" :rows="6" class="mono" />
            <div v-if="editErr.edges" class="err_text">{{ editErr.edges }}</div>
          </el-form-item>
          <el-form-item label="变更说明">
            <el-input v-model="editForm.change_log" maxlength="200" placeholder="记录本次改动（可选）" />
          </el-form-item>
        </el-form>
      </div>
      <div class="drawer_footer">
        <el-button @click="closeEdit">取 消</el-button>
        <el-button type="primary" :loading="editSaving" @click="saveEdit">保存改动</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { agentBody, isAdminAcc } from '../utils'
import { ssePost } from '../sse'

// distill SSE 的 stage 为英文 token（后端固定值），前端映射中文；reflecting 最多 3 轮
const STAGE_TEXT = {
  distilling: '蒸馏生成中', repairing: '修复重试中', staged: '分段生成中',
  fallback: '降级骨架生成中', reflecting: '反思修订中'
}
const STATUS_TEXT = { draft: '草稿', published: '已发布', archived: '已归档', retired: '已退役' }
const STATUS_TAG = { draft: 'info', published: 'success', archived: 'danger', retired: 'warning' }
const GEN_TEXT = { distill: '蒸馏', distill_degraded: '降级蒸馏', manual: '手动' }
const NODE_TEXT = { start: '开始', step: '步骤', confirm: '确认', terminal: '终点' }
const NODE_TAG = { start: 'success', step: '', confirm: 'warning', terminal: 'danger' }

// SOP 技能管理：列表 / 蒸馏 / 版本(patches) / 反思 / 发布 / agent 绑定；个人与企业均可管理自己的技能（owner 由服务端判定）
export default {
  name: 'AiAgentSkills',
  data() {
    return {
      STATUS_TEXT, STATUS_TAG, GEN_TEXT, NODE_TEXT, NODE_TAG,
      queryForm: { name: '', status: '' },
      tableData: [],
      loading: false,
      currentPage: 1,
      pagesize: 20,
      total: 0,
      reqSeq: 0,
      loaded: false,
      // 新建
      addVisible: false,
      addForm: { name: '', summary: '', tags: '' },
      addRules: { name: [{ required: true, message: '请输入技能名', trigger: 'blur' }] },
      submiting: false,
      // 列表行发布（先查版本再确认，防盲发非草稿/降级版）
      pubListId: '',
      // 蒸馏
      distillVisible: false,
      dStep: 0,
      dForm: { kb_id: '', doc_id: '', name: '' },
      kbs: [], kbsLoading: false,
      docs: [], docsLoading: false,
      distilling: false,
      abortCtrl: null,
      dProg: { stages: [], thinks: '', reply: '', result: null },
      // 详情
      detailVisible: false,
      detailTab: 'versions',
      skill: {},
      versions: [], verLoading: false,
      curVer: null,
      // 编辑抽屉
      editVisible: false,
      editSkillId: '',
      editTitle: '',
      editForm: { name: '', summary: '', output_format: '', inputs: [], nodesText: '', edgesText: '', change_log: '' },
      editErr: { nodes: '', edges: '' },
      editSaving: false,
      reflecting: false,
      reflectVer: 0,
      reflectResult: null,
      pubVerNo: 0,
      // 绑定
      bindings: [], bindLoading: false,
      agentOpts: [], agentOptsLoaded: false,
      bindForm: { agent_id: '', version: 0, enabled: true },
      bindSaving: false
    }
  },
  computed: {
    latestGenBy() {
      return this.skill && this.skill.latest_version ? this.skill.latest_version.gen_by : ''
    },
    card() {
      return (this.curVer && this.curVer.card) || {}
    },
    publishedVers() {
      return this.versions.filter(v => v.status === 'published')
    }
  },
  methods: {
    onActivate() {
      if (!this.loaded) this.loadList()
    },
    loadList() {
      this.loading = true
      const seq = ++this.reqSeq
      const data = { page: this.currentPage, limit: this.pagesize }
      if (this.queryForm.name) data.name = this.queryForm.name
      if (this.queryForm.status) data.status = this.queryForm.status
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentSkillsList, agentBody(data)).then((res) => {
        if (seq !== this.reqSeq) return
        if (res.data.code == 0) {
          this.tableData = res.data.data.data || []
          this.total = res.data.data.total || 0
          this.loaded = true
        }
        this.loading = false
      }).catch(() => { if (seq === this.reqSeq) this.loading = false })
    },
    onSearch() { this.currentPage = 1; this.loadList() },
    resetQuery() { this.queryForm = { name: '', status: '' }; this.onSearch() },
    handleSizeChange(val) { this.pagesize = val; this.loadList() },
    handleCurrentChange(val) { this.currentPage = val; this.loadList() },
    fmtTime(s) {
      if (!s) return '-'
      return this.$tools.parserDateTime('datetime', s) || s.substring(0, 19).replace('T', ' ')
    },
    fmtSize(n) {
      if (!n && n !== 0) return '-'
      if (n < 1024) return n + 'B'
      if (n < 1024 * 1024) return (n / 1024).toFixed(1) + 'KB'
      return (n / 1024 / 1024).toFixed(1) + 'MB'
    },

    /* ---------- 新建 ---------- */
    openAdd() {
      this.addForm = { name: '', summary: '', tags: '' }
      this.addVisible = true
      this.$nextTick(() => this.$refs.addForm && this.$refs.addForm.clearValidate())
    },
    submitAdd() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return
        this.submiting = true
        const tags = this.addForm.tags.split(/[,，]/).map(s => s.trim()).filter(Boolean)
        this.$tools.asyncPost(this, this.$baseUrl.aiAgentSkillsAdd,
          agentBody({ name: this.addForm.name, summary: this.addForm.summary || '', tags })).then((res) => {
          if (res.data.code == 0) {
            this.$message({ type: 'success', message: '已创建 v1 草稿' })
            this.addVisible = false
            this.currentPage = 1
            this.loadList()
            if (res.data.data && res.data.data.id) this.openDetail({ skill_id: res.data.data.id })
          }
          this.submiting = false
        }).catch((err) => {
          this.submiting = false
          if (err && err.isAxiosError) this.$message({ type: 'error', message: '网络异常，请稍后重试' })
        })
      })
    },
    handleDel(row) {
      this.$MessageBox.confirm('删除后技能的全部版本与 agent 绑定将一并删除，确认删除？', '提示', { type: 'warning' }).then(() => {
        this.$tools.asyncPost(this, this.$baseUrl.aiAgentSkillsDel,
          agentBody({ skill_id: row.skill_id })).then((res) => {
          if (res.data.code == 0) {
            this.$message({ type: 'success', message: '删除成功' })
            if (this.tableData.length === 1 && this.currentPage > 1) this.currentPage -= 1
            this.loadList()
          }
        }).catch((err) => {
          if (err && err.isAxiosError) this.$message({ type: 'error', message: '网络异常，请稍后重试' })
        })
      }).catch(() => {})
    },

    /* ---------- 列表行发布：先取最新版本校验状态/降级，再确认发布 ---------- */
    pubFromList(row) {
      this.pubListId = row.skill_id
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentSkillVersionsGet,
        agentBody({ skill_id: row.skill_id, version: row.latest_ver })).then((res) => {
        this.pubListId = ''
        if (res.data.code != 0) return
        const v = res.data.data
        if (v.status !== 'draft') return this.$message({ type: 'warning', message: 'v' + v.version + ' 不是草稿，无法发布' })
        if (v.gen_by === 'distill_degraded') return this.$message({ type: 'warning', message: '降级骨架版本禁止直接发布，请先编辑补全流程' })
        this.confirmPublish(row.skill_id, v.version)
      }).catch(() => { this.pubListId = '' })
    },
    confirmPublish(skillId, version) {
      this.$MessageBox.confirm('发布后 v' + version + ' 即刻生效，其余已发布版本将转为已退役，确认发布？', '提示', { type: 'warning' }).then(() => {
        this.pubVerNo = version
        this.$tools.asyncPost(this, this.$baseUrl.aiAgentSkillsPublish,
          agentBody({ skill_id: skillId, version })).then((res) => {
          this.pubVerNo = 0
          if (res.data.code == 0) {
            this.$message({ type: 'success', message: '发布成功' })
            this.loadList()
            if (this.detailVisible && this.skill.skill_id === skillId) this.refreshDetail()
          }
        }).catch(() => { this.pubVerNo = 0 })
      }).catch(() => {})
    },

    /* ---------- 蒸馏 ---------- */
    openDistill() {
      // 兜底中断上一条流（正常路径弹窗关闭时 onDistillBeforeClose 已 abort）
      if (this.abortCtrl) { this.abortCtrl.abort(); this.abortCtrl = null }
      this.dStep = 0
      this.dForm = { kb_id: '', doc_id: '', name: '' }
      this.dProg = { stages: [], thinks: '', reply: '', result: null }
      this.distillVisible = true
      if (!this.kbs.length) this.loadKbs()
    },
    loadKbs() {
      this.kbsLoading = true
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentKbBasesList,
        agentBody({ page: 1, limit: 100 })).then((res) => {
        if (res.data.code == 0) this.kbs = res.data.data.data || []
        this.kbsLoading = false
      }).catch(() => { this.kbsLoading = false })
    },
    onPickKb() {
      this.dForm.doc_id = ''
      this.docs = []
    },
    toStepDocs() {
      this.dStep = 1
      if (!this.docs.length) this.loadDocs()
    },
    loadDocs() {
      this.docsLoading = true
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentKbDocsList,
        agentBody({ kb_id: this.dForm.kb_id, status: 'done', page: 1, limit: 50 })).then((res) => {
        if (res.data.code == 0) this.docs = res.data.data.data || []
        this.docsLoading = false
      }).catch(() => { this.docsLoading = false })
    },
    onPickDoc(row) {
      if (row) this.dForm.doc_id = row.doc_id
    },
    // distill 无幂等：distilling 标志防重复提交；abort 仅停止前端展示，后端仍会完成入库
    async runDistill() {
      this.dStep = 2
      this.distilling = true
      this.abortCtrl = new AbortController()
      try {
        await ssePost(this.$baseUrl.aiAgentSkillsDistill, {
          kb_id: this.dForm.kb_id,
          doc_id: this.dForm.doc_id,
          name: this.dForm.name || ''
        }, {
          onMessage: (evt) => {
            if (evt.kind === 'stage') {
              if (evt.content === 'done') return
              const last = this.dProg.stages[this.dProg.stages.length - 1]
              if (!last || last.key !== evt.content) {
                this.dProg.stages.push({ key: evt.content, text: STAGE_TEXT[evt.content] || evt.content })
              }
            } else if (evt.kind === 'think') {
              this.dProg.thinks += evt.content
            } else {
              this.dProg.reply += evt.content // 技能卡 JSON 流式片段
            }
          },
          onOk: (result) => {
            this.dProg.result = result
            if (result.degraded) this.$message({ type: 'warning', message: '蒸馏降级为骨架版，需编辑补全流程后才能发布' })
            this.loadList()
          },
          onError: (msg) => { this.$message({ type: 'error', message: msg }) },
          // distill 无幂等 ID 且断连后后端继续蒸馏入库，重试会重复生成，明确提示
          disconnectMsg: '连接中断；蒸馏仍在后台进行，完成后刷新列表可见产物，请勿重复发起'
        }, this.abortCtrl.signal)
      } finally {
        this.distilling = false
      }
    },
    cancelDistill() {
      if (this.abortCtrl) this.abortCtrl.abort()
      this.$message({ type: 'info', message: '已停止展示进度；若后端已完成蒸馏，刷新列表可见产物' })
    },
    // 弹窗关闭（X/Esc）：abort 使 ssePost 静默返回，旧任务的回调不再污染下次向导
    onDistillBeforeClose(done) {
      if (this.abortCtrl) this.abortCtrl.abort()
      done()
    },
    viewDistilled() {
      if (this.dProg.result && this.dProg.result.skill_id) {
        this.distillVisible = false
        this.openDetail({ skill_id: this.dProg.result.skill_id })
      }
    },

    /* ---------- 详情 ---------- */
    openDetail(row) {
      this.detailVisible = true
      this.detailTab = 'versions'
      this.skill = {}
      this.versions = []
      this.curVer = null
      this.reflectResult = null
      this.bindForm = { agent_id: '', version: 0, enabled: true }
      this.loadDetail(row.skill_id)
      if (!this.agentOptsLoaded) this.loadAgents()
    },
    loadDetail(skillId) {
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentSkillsGet,
        agentBody({ skill_id: skillId })).then((res) => {
        if (res.data.code == 0) this.skill = res.data.data || {}
      }).catch(() => {})
      this.loadVersions(skillId)
      this.loadBindings(skillId)
    },
    refreshDetail() { this.loadDetail(this.skill.skill_id) },
    loadVersions(skillId) {
      this.verLoading = true
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentSkillVersionsList,
        agentBody({ skill_id: skillId })).then((res) => {
        if (res.data.code == 0) this.versions = res.data.data.data || []
        this.verLoading = false
      }).catch(() => { this.verLoading = false })
    },
    viewVersion(row) {
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentSkillVersionsGet,
        agentBody({ skill_id: this.skill.skill_id, version: row.version })).then((res) => {
        if (res.data.code == 0) {
          this.curVer = res.data.data
          this.reflectResult = null
        }
      }).catch(() => {})
    },
    // patches 编辑：先 get 最新版本（防列表数据过期 + revision 乐观锁），再落编辑表单并从右侧抽屉打开
    startEdit(row, skillId) {
      const sid = skillId || this.editSkillId || (this.skill && this.skill.skill_id)
      if (!sid) return
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentSkillVersionsGet,
        agentBody({ skill_id: sid, version: row.version })).then((res) => {
        if (res.data.code != 0) return
        this.curVer = res.data.data
        this.editSkillId = sid
        const c = this.curVer.card || {}
        this.editForm = {
          name: c.name || '',
          summary: c.summary || '',
          output_format: c.output_format || '',
          inputs: (c.inputs || []).map(x => ({ ...x })),
          nodesText: JSON.stringify(c.nodes || [], null, 2),
          edgesText: JSON.stringify(c.edges || [], null, 2),
          change_log: ''
        }
        this.editErr = { nodes: '', edges: '' }
        this.reflectResult = null
        this.editTitle = '编辑草稿 v' + this.curVer.version
        this.editVisible = true
      }).catch(() => {})
    },
    // 卡片编辑：取该技能最新草稿版本；无草稿时引导去详情复制新版本
    openEditFromCard(row) {
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentSkillVersionsList,
        agentBody({ skill_id: row.skill_id })).then((res) => {
        if (res.data.code != 0) return
        const drafts = (res.data.data.data || [])
          .filter(v => v.status === 'draft')
          .sort((a, b) => b.version - a.version)
        if (!drafts.length) {
          return this.$message({ type: 'warning', message: '暂无草稿版本，请在详情中基于已有版本复制新版本' })
        }
        this.startEdit(drafts[0], row.skill_id)
      }).catch(() => {})
    },
    closeEdit() {
      this.editVisible = false
    },
    // 抽屉挂到 body 后仍可能被更晚打开的详情弹窗蒙版压住，打开后强制提到最上层
    raiseDrawer() {
      this.$nextTick(() => {
        if (this.$el && this.$el.style) this.$el.style.zIndex = 4000
      })
    },
    removeInput(idx) { this.editForm.inputs.splice(idx, 1) },
    parseJsonText(text, field) {
      try {
        const v = JSON.parse(text)
        if (!Array.isArray(v)) throw new Error('必须是 JSON 数组')
        this.editErr[field] = ''
        return v
      } catch (e) {
        this.editErr[field] = 'JSON 解析失败：' + e.message
        return null
      }
    },
    // 仅提交改动字段（数组整体替换语义）；空 patches 不发请求
    buildPatches() {
      const orig = this.curVer.card || {}
      const p = []
      ;['name', 'summary', 'output_format'].forEach(k => {
        if ((orig[k] || '') !== this.editForm[k]) p.push({ path: k, value: this.editForm[k] || '' })
      })
      const inputs = this.editForm.inputs.filter(x => x.name)
      if (JSON.stringify(orig.inputs || []) !== JSON.stringify(inputs)) p.push({ path: 'inputs', value: inputs })
      const nodes = this.parseJsonText(this.editForm.nodesText, 'nodes')
      if (!nodes) return null
      if (JSON.stringify(orig.nodes || []) !== JSON.stringify(nodes)) p.push({ path: 'nodes', value: nodes })
      const edges = this.parseJsonText(this.editForm.edgesText, 'edges')
      if (!edges) return null
      if (JSON.stringify(orig.edges || []) !== JSON.stringify(edges)) p.push({ path: 'edges', value: edges })
      return p
    },
    saveEdit() {
      const patches = this.buildPatches()
      if (patches === null) return
      if (!patches.length) return this.$message({ type: 'info', message: '没有检测到改动' })
      this.editSaving = true
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentSkillVersionsEdit,
        agentBody({ skill_id: this.editSkillId, version: this.curVer.version, patches,
          change_log: this.editForm.change_log || '' })).then((res) => {
        if (res.data.code == 0) {
          this.$message({ type: 'success', message: '已保存 ' + patches.length + ' 处改动' })
          this.editVisible = false
          // 详情弹窗仍打开时同步刷新版本列表与当前版本详情
          if (this.detailVisible && this.skill.skill_id === this.editSkillId) {
            this.refreshDetail()
            this.viewVersion({ version: this.curVer.version })
          }
          this.loadList()
        }
        this.editSaving = false
      }).catch((err) => {
        this.editSaving = false
        // 2002 乐观锁冲突：拦截器已弹后端文案，这里引导刷新重拉
        if (err && err.message && err.message.indexOf('已被修改') >= 0 && this.curVer) {
          this.startEdit({ version: this.curVer.version }, this.editSkillId)
        }
      })
    },
    doReflect(row) {
      this.$MessageBox.confirm('反思为 LLM 重任务，可能耗时 1~2 分钟，期间请勿关闭页面，确认执行？', '提示', { type: 'info' }).then(() => {
        this.reflectVer = row.version
        this.$tools.asyncPost(this, this.$baseUrl.aiAgentSkillsReflect,
          agentBody({ skill_id: this.skill.skill_id, version: row.version })).then((res) => {
          this.reflectVer = 0
          if (res.data.code == 0) {
            this.reflectResult = res.data.data || { issues: [], applied: 0 }
            this.refreshDetail()
            this.viewVersion({ version: row.version })
          }
        }).catch(() => { this.reflectVer = 0 })
      }).catch(() => {})
    },
    pubVersion(row) {
      if (row.gen_by === 'distill_degraded') {
        return this.$message({ type: 'warning', message: '降级骨架版本禁止直接发布，请先编辑补全流程' })
      }
      this.confirmPublish(this.skill.skill_id, row.version)
    },
    newVersion(row) {
      this.$MessageBox.confirm('将基于 v' + row.version + ' 复制一个新草稿版本，确认继续？', '提示', { type: 'info' }).then(() => {
        this.$tools.asyncPost(this, this.$baseUrl.aiAgentSkillVersionsNew,
          agentBody({ skill_id: this.skill.skill_id, base_version: row.version, change_log: '基于 v' + row.version + ' 复制' })).then((res) => {
          if (res.data.code == 0) {
            this.$message({ type: 'success', message: '已创建 v' + (res.data.data ? res.data.data.version : '') + ' 草稿' })
            this.refreshDetail()
            this.loadList()
          }
        }).catch(() => {})
      }).catch(() => {})
    },

    /* ---------- 绑定 ---------- */
    loadAgents() {
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentAgentsList,
        agentBody({ page: 1, limit: 0 })).then((res) => {
        if (res.data.code == 0) {
          this.agentOpts = res.data.data.data || []
          this.agentOptsLoaded = true
        }
      }).catch(() => {})
    },
    agentName(id) {
      const a = this.agentOpts.find(x => x.agent_id === id)
      return a ? (a.display_name || a.name) : id
    },
    loadBindings(skillId) {
      this.bindLoading = true
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentSkillBindingsList,
        agentBody({ skill_id: skillId })).then((res) => {
        if (res.data.code == 0) this.bindings = res.data.data.data || []
        this.bindLoading = false
      }).catch(() => { this.bindLoading = false })
    },
    saveBind() {
      if (!this.bindForm.agent_id) return this.$message({ type: 'warning', message: '请选择数字员工' })
      this.bindSaving = true
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentSkillBindingsSet,
        agentBody({ agent_id: this.bindForm.agent_id, skill_id: this.skill.skill_id,
          version: this.bindForm.version, enabled: this.bindForm.enabled })).then((res) => {
        if (res.data.code == 0) {
          this.$message({ type: 'success', message: '绑定已保存' })
          this.loadBindings(this.skill.skill_id)
        }
        this.bindSaving = false
      }).catch((err) => {
        this.bindSaving = false
        if (err && err.isAxiosError) this.$message({ type: 'error', message: '网络异常，请稍后重试' })
      })
    },
    delBind(row) {
      this.$MessageBox.confirm('确认解除该数字员工与此技能的绑定？', '提示', { type: 'warning' }).then(() => {
        this.$tools.asyncPost(this, this.$baseUrl.aiAgentSkillBindingsDel,
          agentBody({ agent_id: row.agent_id, skill_id: row.skill_id })).then((res) => {
          if (res.data.code == 0) {
            this.$message({ type: 'success', message: '已解绑' })
            this.loadBindings(this.skill.skill_id)
          }
        }).catch(() => {})
      }).catch(() => {})
    }
  },
  mounted() {
    // 管理员无 owner，常驻挂载下发 owner 型请求会 1002 弹错，跳过自动加载
    if (isAdminAcc()) return
    this.loadList()
  },
  beforeDestroy() {
    // 路由离开中断进行中的蒸馏流（后端仍会继续执行并入库）
    if (this.abortCtrl) this.abortCtrl.abort()
  }
}
</script>

<style lang="less" scoped>
// 生成内容为 JSON/脚本片段，按代码块风格展示（非 markdown）；公共样式见 code-view.less
@import '../code-view.less';
.staff_head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  padding: 0 12px;
  margin-bottom: 10px;
  background: #fff;
  border-bottom: 1px solid #e4e7ed;
  box-sizing: border-box;
  .query_form {
    /deep/ .el-form-item {
      margin: 0 10px 0 0;
    }
    /deep/ .el-form-item:last-child {
      margin-right: 0;
    }
    /deep/ .el-form-item__label {
      line-height: 32px;
    }
  }
  .head_actions {
    display: flex;
    align-items: center;
    .el-button + .el-button {
      margin-left: 8px;
    }
  }
}
.danger_text { color: #f56c6c; }
// 卡片列表：与规则列表页一致的卡片样式
.skills_wrap {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
}
.skill_cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));
  gap: 12px;
  padding: 12px;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  background: #f9fafd;
  border-top: 1px solid #e9eaec;
  // 滚动条只出现在卡片区内部右侧
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #ccc;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
}
// 底部分页：固定在卡片区下方，与数字员工页一致
.pager_bar {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 8px 12px;
  background: #fff;
  border-top: 1px solid #f0f0f0;
  box-sizing: border-box;
}
.skill_card {
  display: flex;
  flex-direction: column;
  max-height: 232px;
  padding: 12px 12px 5px 12px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 1px 1px 4px #c0bfbf;
}
.card_head {
  display: flex;
  align-items: center;
  gap: 8px;
  .card_icon { color: #409eff; font-size: 16px; }
  .card_name {
    flex: 1;
    min-width: 0;
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .card_del {
    color: #c0c4cc;
    cursor: pointer;
    &:hover { color: #f56c6c; }
  }
}
.card_summary {
  height: 36px;
  margin: 8px 0;
  font-size: 12px;
  line-height: 18px;
  color: #909399;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.card_meta {
  font-size: 12px;
  color: #606266;
  .meta_row {
    display: flex;
    justify-content: space-between;
    padding: 2px 0;
  }
  .meta_k { color: #909399; }
}
.card_tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  max-height: 22px;
  margin-top: 8px;
  overflow: hidden;
  .tag_empty { font-size: 12px; color: #c0c4cc; }
}
.card_actions {
  display: flex;
  align-items: center;
  margin-top: auto;
  padding-top: 2px;
  border-top: 1px solid #f2f2f2;
}
.cards_empty { grid-column: 1 / -1; }
// 编辑抽屉：头部标题 + 可滚动表单 + 底部操作
.skill_drawer {
  /deep/ .el-drawer__body {
    display: flex;
    flex-direction: column;
    padding: 0;
    overflow: hidden;
  }
}
.drawer_head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 52px;
  padding: 0 20px;
  border-bottom: 1px solid #ebeef5;
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  .drawer_close {
    font-size: 20px;
    color: #909399;
    cursor: pointer;
    &:hover { color: #f56c6c; }
  }
}
.drawer_body {
  flex: 1;
  padding: 16px 20px 8px;
  overflow: auto;
}
.drawer_footer {
  padding: 12px 20px;
  border-top: 1px solid #ebeef5;
  text-align: right;
}
.d_step { margin-top: 16px; }
.stage_list { margin: 8px 0 12px; }
.stage_item {
  padding: 4px 0;
  color: #606266;
  .stage_ok { color: #67c23a; margin-right: 6px; }
  .stage_run { color: #409eff; margin-right: 6px; }
}
.stage_empty { color: #909399; padding: 8px 0; font-size: 13px; }
.stream_pre {
  max-height: 200px;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-all;
  background: #f5f7fa;
  padding: 8px;
  font-size: 12px;
  margin: 0;
}
.result_card {
  margin-top: 12px;
  .el-alert { margin-bottom: 8px; }
}
.kv {
  display: flex;
  padding: 3px 0;
  font-size: 13px;
  .k {
    width: 80px;
    flex-shrink: 0;
    color: #909399;
  }
}
.detail_body {
  max-height: 68vh;
  overflow: auto;
}
.skill_info { margin-bottom: 8px; }
h4 { margin: 12px 0 8px; font-size: 14px; }
h5 { margin: 12px 0 6px; font-size: 13px; color: #606266; }
.ver_meta { font-size: 12px; color: #909399; font-weight: normal; margin-left: 10px; }
.node_card {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 8px 10px;
  margin-bottom: 8px;
  .node_head {
    display: flex;
    align-items: center;
    gap: 8px;
    b { font-size: 12px; color: #909399; }
    .node_title { font-size: 13px; }
  }
  .node_detail {
    font-size: 12px;
    color: #606266;
    background: #f5f7fa;
    padding: 6px 8px;
    margin: 6px 0;
    white-space: pre-wrap;
  }
  .node_meta {
    font-size: 12px;
    color: #909399;
    display: flex;
    gap: 16px;
  }
}
.add_input_btn { margin-top: 6px; }
.mono /deep/ textarea {
  font-family: Menlo, Consolas, monospace;
  font-size: 12px;
}
.err_text { color: #f56c6c; font-size: 12px; line-height: 1.4; }
.reflect_box {
  margin-top: 12px;
  border-top: 1px dashed #dcdfe6;
  padding-top: 8px;
  .issue_item { padding: 4px 0; font-size: 13px; .el-tag { margin-right: 8px; } }
}
.bind_bar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 10px;
}
</style>
